import { FilesView } from 'api/clients/FilesViewsClient'
import { Property } from 'api/clients/PropertyClient'
import { showToastMessage } from 'common/ToastMessage/ShowToastMessage'
import { dismissToastMessages } from 'common/ToastMessage'
import { TemplateType, templates } from 'components/FolderTemplatesDialog/Templates'
import { useRefresh } from 'components/Handbook2_0/HandbookSettings/Workflow/useRefresh'
import { workflowFromTemplate } from 'components/Handbook2_0/HandbookSettings/Workflow/utils'
import { useCreateWorkflow } from 'hooks/queries/workflow/useCreateWorkflow'
import { IWorkflow, StatePropertyValue } from 'stores/Workflows/Types'
import { Workflow } from 'stores/Workflows/Workflow'
import { AlmanacFile, ViewType } from 'types'

interface Props {
  filesView?: FilesView
  currentFolder: AlmanacFile
  callback: ({ viewType }: { viewType: ViewType }) => void
}

export const useBoardView = ({ filesView, callback, currentFolder }: Props) => {
  const { mutate } = useCreateWorkflow({ folderId: currentFolder.id })
  const { refresh } = useRefresh({ folderKey: currentFolder.key, handbookKey: currentFolder.handbook?.key })

  const createWorkflow = () => {
    if (!!filesView?.schema.workflow_property) {
      callback({ viewType: ViewType.Board })

      return
    }

    const template = templates.find((t) => t.id === TemplateType.Default)
    if (!template) return

    const newWorkflow = Workflow.fromJSON(
      workflowFromTemplate({
        template,
        workflowData: {
          users: [],
          channels: [],
          configuration: {},
          folder: { key: currentFolder.id } as IWorkflow['folder'],
          property: { property_values: template.statuses.property_values } as Property<StatePropertyValue>,
        },
      }),
    )

    const { configuration, property_values } = newWorkflow.toJSON()
    showToastMessage('Creating workflow...', 'loading')
    mutate(
      {
        property_values: property_values,
        config: configuration,
      },
      {
        onSuccess: async () => {
          dismissToastMessages()
          showToastMessage('Workflow created', 'success')
          await refresh()
          callback({ viewType: ViewType.Board })
        },
        onError() {
          dismissToastMessages()
          showToastMessage('An error occurred, our team has been notified.', 'error')
        },
      },
    )
  }

  return {
    createWorkflow,
  }
}
